export default __webpack_public_path__ + "static/media/logovolcano.1fb51fbf.png";